<template>
  <material-card
    :title="title"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs12
            md6>
            <v-select
              v-model="ifsf.countryCode"
              :items="countryCodes"
              :rules="rules.required"
              :label="`${ $t('Country code') }`"
              item-text="country"
              item-value="code"
              class="dover-input"
              chips>
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="data.item.code"
                  class="v-chip--select-multi "
                  @input="data.parent.selectItem(data.item)">
                  <v-avatar class="dover-avatar "> {{ data.item.code }} </v-avatar>
                  {{ data.item.country }}
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.trim="ifsf.tlgModel"
              :rules="rules.required.concat(rules.max3)"
              :counter="3"
              :label="`${ $t('TLG model') }`"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-select
              v-model="ifsf.node"
              :items="nodes"
              :rules="rules.required"
              :label="`${ $t('Address node') }`"
              item-text="desc"
              item-value="code"
              class="dover-input"
              chips>
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="data.item.code"
                  class="v-chip--select-multi "
                  @input="data.parent.selectItem(data.item)">
                  <v-avatar class="dover-avatar "> {{ data.item.code }} </v-avatar>
                  {{ data.item.desc }}
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.trim="ifsf.tlgSerial"
              :rules="rules.required.concat(rules.max12)"
              :counter="12"
              :label="`${ $t('TLG serial') }`"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <MaglinkComponentPassword
              :label="`${ $t('Password') }`"
              :initial-value="ifsf.password"
              :rules="rules.required.concat(rules.max6)"
              comp-key="login"
              @onPasswordChange="onPasswordChange" />
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.trim="ifsf.tlgType"
              :rules="rules.required.concat(rules.max3)"
              :counter="3"
              :label="`${ $t('TLG type') }`"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md8
            text-xs-right/>
          <v-flex
            xs12
            md4
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="save">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>

import Vue from 'vue'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isValidationOk: false,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      max3: [ v => Vue.prototype.Maglink.RulesMaxLen(v, 3) ],
      max6: [ v => Vue.prototype.Maglink.RulesMaxLen(v, 6) ],
      max12: [ v => Vue.prototype.Maglink.RulesMaxLen(v, 12) ]
    },
    nodes: [],
    countryCodes: [],
    ifsf: {}
  }),
  mounted () {
    this.Maglink.GetOptions()
      .then(response => {
        this.nodes = response.data.ifsfNodes
        // sort by desc
        this.countryCodes.sort((a, b) => (a.desc > b.desc) ? 1 : -1)
      })
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetCountries()
      .then(response => (this.countryCodes = response.data))
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetSettings('IFSFSettings')
      .then(response => (this.ifsf = { ...this.ifsf, ...response.data }))
      .catch(error => (this.snack('error', error.message)))
  },
  methods: {
    onPasswordChange (newPassword, compKey) {
      this.ifsf.password = newPassword
    },
    save (event) {
      if (this.$refs.form.validate()) {
        this.isValidationOk = true

        this.Maglink.SetSettings('IFSFSettings', this.ifsf)
          .then(response => (this.snack('success', response.data['done'])))
          .catch(error => (this.snack('error', error.message)))

        this.$emit('settingsSaved')
      } else {
        this.isValidationOk = false
      }
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
